import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-shopping-cart-svg-icon',
  imports: [NgClass],
  templateUrl: './shopping-cart-svg-icon.component.html',
  styleUrl: './shopping-cart-svg-icon.component.css',
})
export class ShoppingCartSvgIconComponent {
  @Input() class = 'w-6 h-6';
}
